// src/pages/MagicLogin.js
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function MagicLogin() {
  const [params]       = useSearchParams();
  const navigate       = useNavigate();
  const { setUser }    = useAuth();
  const [status, setStatus] = useState("verifying"); // verifying | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); setMessage("No login token found in the URL."); return; }

    fetch("/api/auth/magic", {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify({ token }),
    })
      .then(r => r.json().then(d => ({ ok: r.ok, data: d })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data.error || "Login failed");
        setUser({ email: data.email, name: data.name, role: data.role, isExternal: true });
        navigate("/my-training", { replace: true });
      })
      .catch(err => { setStatus("error"); setMessage(err.message); });
  }, []); // eslint-disable-line

  const PRIMARY = "#1F2937";

  return (
    <div style={{ minHeight:"100vh", background:"#F3F4F6", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Segoe UI',system-ui,sans-serif" }}>
      <div style={{ textAlign:"center", padding:40 }}>
        {status === "verifying" && (
          <>
            <div className="spinner" style={{ width:36, height:36, margin:"0 auto 16px" }} />
            <p style={{ fontSize:16, color:"#6B7280" }}>Verifying your login link…</p>
          </>
        )}
        {status === "error" && (
          <>
            <div style={{ fontSize:48, marginBottom:16 }}>⚠️</div>
            <h2 style={{ fontSize:20, fontWeight:700, color:"#111827", marginBottom:8 }}>Login link invalid</h2>
            <p style={{ fontSize:14, color:"#6B7280", marginBottom:20, maxWidth:300, lineHeight:1.6 }}>{message}</p>
            <a href="/" style={{ display:"inline-block", background:PRIMARY, color:"#fff", textDecoration:"none", padding:"10px 24px", borderRadius:8, fontSize:14, fontWeight:600 }}>
              Back to Login
            </a>
          </>
        )}
      </div>
    </div>
  );
}
